<template>
    <Modal :show="show" :max-width="maxWidth" :closeable="closeable" @close="close">
        <div class="text-lg font-bold px-4 py-3 rounded-t-lg" :class="[backgroundClass, textClass]">
            <slot name="title" />
        </div>
        
        <div class="px-4 py-2 bg-white">
            <slot name="content" />
        </div>

        <div class="flex flex-row justify-end px-4 py-2 bg-gray-200 text-right rounded-b-lg">
            <slot name="footer" />
        </div>
    </Modal>
</template>

<script>
    import Modal from './Modal.vue'
    import { defineComponent } from 'vue'

    export default defineComponent({
        emits: ['close'],

        components: {
            Modal
        },

        props: {
            show: {
                default: false
            },
            maxWidth: {
                default: '2xl'
            },
            closeable: {
                default: true
            },
            backgroundClass: {
                type: String,
                default: "bg-sky-500"
            },
            textClass: {
                type: String,
                default: "text-white"
            },
        },

        methods: {
            close() {
                this.$emit('close')
            },
        }
    })
</script>
